import { Case } from "./types";

export const countries: Case[] = [
  { title: "Afghanistan", identifier: "AF" },
  { title: "Åland Islands", identifier: "AX" },
  { title: "Albania", identifier: "AL" },
  { title: "Algeria", identifier: "DZ" },
  { title: "American Samoa", identifier: "AS" },
  { title: "AndorrA", identifier: "AD" },
  { title: "Angola", identifier: "AO" },
  { title: "Anguilla", identifier: "AI" },
  { title: "Antarctica", identifier: "AQ" },
  { title: "Antigua and Barbuda", identifier: "AG" },
  { title: "Argentina", identifier: "AR" },
  { title: "Armenia", identifier: "AM" },
  { title: "Aruba", identifier: "AW" },
  { title: "Australia", identifier: "AU" },
  { title: "Austria", identifier: "AT" },
  { title: "Azerbaijan", identifier: "AZ" },
  { title: "Bahamas", identifier: "BS" },
  { title: "Bahrain", identifier: "BH" },
  { title: "Bangladesh", identifier: "BD" },
  { title: "Barbados", identifier: "BB" },
  { title: "Belarus", identifier: "BY" },
  { title: "Belgium", identifier: "BE" },
  { title: "Belize", identifier: "BZ" },
  { title: "Benin", identifier: "BJ" },
  { title: "Bermuda", identifier: "BM" },
  { title: "Bhutan", identifier: "BT" },
  { title: "Bolivia", identifier: "BO" },
  { title: "Bosnia and Herzegovina", identifier: "BA" },
  { title: "Botswana", identifier: "BW" },
  { title: "Bouvet Island", identifier: "BV" },
  { title: "Brazil", identifier: "BR" },
  { title: "British Indian Ocean Territory", identifier: "IO" },
  { title: "Brunei Darussalam", identifier: "BN" },
  { title: "Bulgaria", identifier: "BG" },
  { title: "Burkina Faso", identifier: "BF" },
  { title: "Burundi", identifier: "BI" },
  { title: "Cambodia", identifier: "KH" },
  { title: "Cameroon", identifier: "CM" },
  { title: "Canada", identifier: "CA" },
  { title: "Cape Verde", identifier: "CV" },
  { title: "Cayman Islands", identifier: "KY" },
  { title: "Central African Republic", identifier: "CF" },
  { title: "Chad", identifier: "TD" },
  { title: "Chile", identifier: "CL" },
  { title: "China", identifier: "CN" },
  { title: "Christmas Island", identifier: "CX" },
  { title: "Cocos (Keeling) Islands", identifier: "CC" },
  { title: "Colombia", identifier: "CO" },
  { title: "Comoros", identifier: "KM" },
  { title: "Congo", identifier: "CG" },
  { title: "Congo, The Democratic Republic of the", identifier: "CD" },
  { title: "Cook Islands", identifier: "CK" },
  { title: "Costa Rica", identifier: "CR" },
  { title: "Cote D'Ivoire", identifier: "CI" },
  { title: "Croatia", identifier: "HR" },
  { title: "Cuba", identifier: "CU" },
  { title: "Cyprus", identifier: "CY" },
  { title: "Czech Republic", identifier: "CZ" },
  { title: "Denmark", identifier: "DK" },
  { title: "Djibouti", identifier: "DJ" },
  { title: "Dominica", identifier: "DM" },
  { title: "Dominican Republic", identifier: "DO" },
  { title: "Ecuador", identifier: "EC" },
  { title: "Egypt", identifier: "EG" },
  { title: "El Salvador", identifier: "SV" },
  { title: "Equatorial Guinea", identifier: "GQ" },
  { title: "Eritrea", identifier: "ER" },
  { title: "Estonia", identifier: "EE" },
  { title: "Ethiopia", identifier: "ET" },
  { title: "Falkland Islands (Malvinas)", identifier: "FK" },
  { title: "Faroe Islands", identifier: "FO" },
  { title: "Fiji", identifier: "FJ" },
  { title: "Finland", identifier: "FI" },
  { title: "France", identifier: "FR" },
  { title: "French Guiana", identifier: "GF" },
  { title: "French Polynesia", identifier: "PF" },
  { title: "French Southern Territories", identifier: "TF" },
  { title: "Gabon", identifier: "GA" },
  { title: "Gambia", identifier: "GM" },
  { title: "Georgia", identifier: "GE" },
  { title: "Germany", identifier: "DE" },
  { title: "Ghana", identifier: "GH" },
  { title: "Gibraltar", identifier: "GI" },
  { title: "Greece", identifier: "GR" },
  { title: "Greenland", identifier: "GL" },
  { title: "Grenada", identifier: "GD" },
  { title: "Guadeloupe", identifier: "GP" },
  { title: "Guam", identifier: "GU" },
  { title: "Guatemala", identifier: "GT" },
  { title: "Guernsey", identifier: "GG" },
  { title: "Guinea", identifier: "GN" },
  { title: "Guinea-Bissau", identifier: "GW" },
  { title: "Guyana", identifier: "GY" },
  { title: "Haiti", identifier: "HT" },
  { title: "Heard Island and Mcdonald Islands", identifier: "HM" },
  { title: "Holy See (Vatican City State)", identifier: "VA" },
  { title: "Honduras", identifier: "HN" },
  { title: "Hong Kong", identifier: "HK" },
  { title: "Hungary", identifier: "HU" },
  { title: "Iceland", identifier: "IS" },
  { title: "India", identifier: "IN" },
  { title: "Indonesia", identifier: "ID" },
  { title: "Iran, Islamic Republic Of", identifier: "IR" },
  { title: "Iraq", identifier: "IQ" },
  { title: "Ireland", identifier: "IE" },
  { title: "Isle of Man", identifier: "IM" },
  { title: "Israel", identifier: "IL" },
  { title: "Italy", identifier: "IT" },
  { title: "Jamaica", identifier: "JM" },
  { title: "Japan", identifier: "JP" },
  { title: "Jersey", identifier: "JE" },
  { title: "Jordan", identifier: "JO" },
  { title: "Kazakhstan", identifier: "KZ" },
  { title: "Kenya", identifier: "KE" },
  { title: "Kiribati", identifier: "KI" },
  { title: "Korea, Democratic People'S Republic of", identifier: "KP" },
  { title: "Korea, Republic of", identifier: "KR" },
  { title: "Kuwait", identifier: "KW" },
  { title: "Kyrgyzstan", identifier: "KG" },
  { title: "Lao People'S Democratic Republic", identifier: "LA" },
  { title: "Latvia", identifier: "LV" },
  { title: "Lebanon", identifier: "LB" },
  { title: "Lesotho", identifier: "LS" },
  { title: "Liberia", identifier: "LR" },
  { title: "Libyan Arab Jamahiriya", identifier: "LY" },
  { title: "Liechtenstein", identifier: "LI" },
  { title: "Lithuania", identifier: "LT" },
  { title: "Luxembourg", identifier: "LU" },
  { title: "Macao", identifier: "MO" },
  { title: "Macedonia, The Former Yugoslav Republic of", identifier: "MK" },
  { title: "Madagascar", identifier: "MG" },
  { title: "Malawi", identifier: "MW" },
  { title: "Malaysia", identifier: "MY" },
  { title: "Maldives", identifier: "MV" },
  { title: "Mali", identifier: "ML" },
  { title: "Malta", identifier: "MT" },
  { title: "Marshall Islands", identifier: "MH" },
  { title: "Martinique", identifier: "MQ" },
  { title: "Mauritania", identifier: "MR" },
  { title: "Mauritius", identifier: "MU" },
  { title: "Mayotte", identifier: "YT" },
  { title: "Mexico", identifier: "MX" },
  { title: "Micronesia, Federated States of", identifier: "FM" },
  { title: "Moldova, Republic of", identifier: "MD" },
  { title: "Monaco", identifier: "MC" },
  { title: "Mongolia", identifier: "MN" },
  { title: "Montserrat", identifier: "MS" },
  { title: "Morocco", identifier: "MA" },
  { title: "Mozambique", identifier: "MZ" },
  { title: "Myanmar", identifier: "MM" },
  { title: "Namibia", identifier: "NA" },
  { title: "Nauru", identifier: "NR" },
  { title: "Nepal", identifier: "NP" },
  { title: "Netherlands", identifier: "NL" },
  { title: "Netherlands Antilles", identifier: "AN" },
  { title: "New Caledonia", identifier: "NC" },
  { title: "New Zealand", identifier: "NZ" },
  { title: "Nicaragua", identifier: "NI" },
  { title: "Niger", identifier: "NE" },
  { title: "Nigeria", identifier: "NG" },
  { title: "Niue", identifier: "NU" },
  { title: "Norfolk Island", identifier: "NF" },
  { title: "Northern Mariana Islands", identifier: "MP" },
  { title: "Norway", identifier: "NO" },
  { title: "Oman", identifier: "OM" },
  { title: "Pakistan", identifier: "PK" },
  { title: "Palau", identifier: "PW" },
  { title: "Palestinian Territory, Occupied", identifier: "PS" },
  { title: "Panama", identifier: "PA" },
  { title: "Papua New Guinea", identifier: "PG" },
  { title: "Paraguay", identifier: "PY" },
  { title: "Peru", identifier: "PE" },
  { title: "Philippines", identifier: "PH" },
  { title: "Pitcairn", identifier: "PN" },
  { title: "Poland", identifier: "PL" },
  { title: "Portugal", identifier: "PT" },
  { title: "Puerto Rico", identifier: "PR" },
  { title: "Qatar", identifier: "QA" },
  { title: "Reunion", identifier: "RE" },
  { title: "Romania", identifier: "RO" },
  { title: "Russian Federation", identifier: "RU" },
  { title: "RWANDA", identifier: "RW" },
  { title: "Saint Helena", identifier: "SH" },
  { title: "Saint Kitts and Nevis", identifier: "KN" },
  { title: "Saint Lucia", identifier: "LC" },
  { title: "Saint Pierre and Miquelon", identifier: "PM" },
  { title: "Saint Vincent and the Grenadines", identifier: "VC" },
  { title: "Samoa", identifier: "WS" },
  { title: "San Marino", identifier: "SM" },
  { title: "Sao Tome and Principe", identifier: "ST" },
  { title: "Saudi Arabia", identifier: "SA" },
  { title: "Senegal", identifier: "SN" },
  { title: "Serbia and Montenegro", identifier: "CS" },
  { title: "Seychelles", identifier: "SC" },
  { title: "Sierra Leone", identifier: "SL" },
  { title: "Singapore", identifier: "SG" },
  { title: "Slovakia", identifier: "SK" },
  { title: "Slovenia", identifier: "SI" },
  { title: "Solomon Islands", identifier: "SB" },
  { title: "Somalia", identifier: "SO" },
  { title: "South Africa", identifier: "ZA" },
  { title: "South Georgia and the South Sandwich Islands", identifier: "GS" },
  { title: "Spain", identifier: "ES" },
  { title: "Sri Lanka", identifier: "LK" },
  { title: "Sudan", identifier: "SD" },
  { title: "Surititle", identifier: "SR" },
  { title: "Svalbard and Jan Mayen", identifier: "SJ" },
  { title: "Swaziland", identifier: "SZ" },
  { title: "Sweden", identifier: "SE" },
  { title: "Switzerland", identifier: "CH" },
  { title: "Syrian Arab Republic", identifier: "SY" },
  { title: "Taiwan, Province of China", identifier: "TW" },
  { title: "Tajikistan", identifier: "TJ" },
  { title: "Tanzania, United Republic of", identifier: "TZ" },
  { title: "Thailand", identifier: "TH" },
  { title: "Timor-Leste", identifier: "TL" },
  { title: "Togo", identifier: "TG" },
  { title: "Tokelau", identifier: "TK" },
  { title: "Tonga", identifier: "TO" },
  { title: "Trinidad and Tobago", identifier: "TT" },
  { title: "Tunisia", identifier: "TN" },
  { title: "Turkey", identifier: "TR" },
  { title: "Turkmenistan", identifier: "TM" },
  { title: "Turks and Caicos Islands", identifier: "TC" },
  { title: "Tuvalu", identifier: "TV" },
  { title: "Uganda", identifier: "UG" },
  { title: "Ukraine", identifier: "UA" },
  { title: "United Arab Emirates", identifier: "AE" },
  { title: "United Kingdom", identifier: "GB" },
  { title: "United States", identifier: "US" },
  { title: "United States Minor Outlying Islands", identifier: "UM" },
  { title: "Uruguay", identifier: "UY" },
  { title: "Uzbekistan", identifier: "UZ" },
  { title: "Vanuatu", identifier: "VU" },
  { title: "Venezuela", identifier: "VE" },
  { title: "Viet Nam", identifier: "VN" },
  { title: "Virgin Islands, British", identifier: "VG" },
  { title: "Virgin Islands, U.S.", identifier: "VI" },
  { title: "Wallis and Futuna", identifier: "WF" },
  { title: "Western Sahara", identifier: "EH" },
  { title: "Yemen", identifier: "YE" },
  { title: "Zambia", identifier: "ZM" },
  { title: "Zimbabwe", identifier: "ZW" },
];
